import { useEffect, useRef, type ReactNode } from 'react';
import { IconX } from './Icons';

/** Native <dialog>: focus trap, Escape and the inert background come from the platform. */
export function Dialog({ title, onClose, children, wide }: { title: string; onClose(): void; children: ReactNode; wide?: boolean }) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (!d.open) d.showModal();
    // showModal() focuses the first focusable element (the close button). Move focus to the field that matters on
    // the next frame, after the browser's own dialog focusing steps (and React StrictMode's second effect pass).
    const raf = requestAnimationFrame(() => d.querySelector<HTMLElement>('[data-autofocus]')?.focus());
    return () => { cancelAnimationFrame(raf); if (d.open) d.close(); };
  }, []);
  return (
    <dialog ref={ref} className={wide ? 'dialog dialog--wide' : 'dialog'} aria-label={title}
      onCancel={(e) => { e.preventDefault(); onClose(); }}
      onClick={(e) => { if (e.target === ref.current) onClose(); }}>
      <div className="dialog__body">
        <header className="dialog__head">
          <h2>{title}</h2>
          <button type="button" className="icon-btn" onClick={onClose} aria-label="Close"><IconX size={18} /></button>
        </header>
        {children}
      </div>
    </dialog>
  );
}
